// import "../sass/theme.scss";

// Our modules / classes
import example from './modules/Example'
import AdvancedSearch from './modules/advanced_search'
import Shop_filters from './modules/shop_filters'

const MyExample = new example()
const MyAdvancedSearch = new AdvancedSearch()
const MyShop_filters = new Shop_filters()
